import Image from "next/image";

export const CustomImage = ({ src, alt, ...props }: Parameters<typeof Image>[0]) => {
  return (
      <Image src={src} alt={alt ?? ""} {...props} />
  )
}